/* eslint-disable no-underscore-dangle */
import {useLazyQuery, useQuery} from '@apollo/client';
import {Add} from '@material-ui/icons';
import Skeleton from '@material-ui/lab/Skeleton';
import {GET_TOURNAMENTS, GET_GROUPS} from 'packages/graphql/v2/queries';
import {GetTournamentsData} from 'packages/common-types/queries-types';
import StyledButton from 'packages/common-ui/StyledButton';
import CreateGroup from 'packages/dialogs/CreateGroup';
import {useModal} from 'packages/hooks/use-modal';
import {useState} from 'react';
import Select from 'react-select';
import {Group} from 'packages/common-types/schema-types';
import GroupsTable from './Table';

type GetGroupsVars = {
  tournamentId: string;
};
type GetGroupsData = {
  getGroups: Group[];
};

const Groups = () => {
  const [selectedTournment, setSelectedTournment] = useState<any>('');
  const {toggle, modalOpen} = useModal();
  const {data, loading} = useQuery<GetTournamentsData>(GET_TOURNAMENTS);
  const [loadPreviousGroups, {data: dataGroups, refetch: refetchGroup}] =
    useLazyQuery<GetGroupsData, GetGroupsVars>(GET_GROUPS);
  const handleSelectTournament = (val: any) => {
    loadPreviousGroups({
      variables: {
        tournamentId: val?._id,
      },
    });
    setSelectedTournment(val);
  };
  return (
    <>
      <CreateGroup
        selectedTournament={selectedTournment}
        toggle={toggle}
        modalOpen={modalOpen}
        dataGroup={dataGroups?.getGroups}
        refetchGroup={refetchGroup}
      />
      <div
        style={{
          marginTop: 30,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div style={{width: 600}}>
          {!data || loading ? (
            <Skeleton height={50} />
          ) : (
            <Select
              placeholder="Selecciona un torneo "
              onChange={handleSelectTournament}
              value={selectedTournment}
              options={data?.getTournaments.filter((tournament) => {
                if (tournament.conditions.modalityGame !== 'Individual') {
                  return true;
                }
                return false;
              })}
              getOptionLabel={(option) =>
                `${option.name}:${option.conditions.modalityGame}`
              }
              getOptionValue={(option) => option}
            />
          )}
        </div>
        {selectedTournment && (
          <StyledButton
            onClick={toggle}
            startIcon={<Add />}
            disabled={
              selectedTournment.status === 'Iniciado' ||
              selectedTournment.inscriptions.length < 2
            }
          >
            Crear grupo
          </StyledButton>
        )}
      </div>
      {selectedTournment && (
        <GroupsTable
          tournament={selectedTournment}
          dataGroup={dataGroups?.getGroups}
          refetchGroup={refetchGroup}
        />
      )}
    </>
  );
};

export default Groups;
